import { useQuery } from "@tanstack/react-query";
import { get } from "../services/api";
import {
  getTenantPreviewHost,
  getTenantPreviewSlug,
} from "../utils/tenantPreview";

const DEFAULT_STALE_TIME = 5 * 60 * 1000;

export function getPublicConfigQueryKey(
  slug = getTenantPreviewSlug(),
  host = getTenantPreviewHost(),
  authKey = ""
) {
  return ["public-config", slug || "", slug ? "" : host || "", authKey || ""];
}

export function usePublicConfig(options = {}) {
  const tenantPreviewSlug = getTenantPreviewSlug();
  const tenantPreviewHost = getTenantPreviewHost();
  const {
    enabled = true,
    staleTime = DEFAULT_STALE_TIME,
    retry = 1,
    tenantSlug = "",
    tenantHost = "",
    authKey = "",
    ...rest
  } = options;
  const scopedTenantSlug = `${tenantSlug || tenantPreviewSlug || ""}`.trim().toLowerCase();
  const scopedTenantHost = scopedTenantSlug
    ? ""
    : `${tenantHost || tenantPreviewHost || ""}`.trim().toLowerCase();

  return useQuery({
    queryKey: getPublicConfigQueryKey(scopedTenantSlug, scopedTenantHost, authKey),
    queryFn: async () => {
      const query = scopedTenantSlug ? `?tenant=${encodeURIComponent(scopedTenantSlug)}` : "";
      const config = scopedTenantSlug
        ? { headers: { "x-tenant-slug": scopedTenantSlug } }
        : {};
      const response = await get(`/api/v1/users/public-config${query}`, config);
      return response.data || {};
    },
    enabled,
    staleTime,
    retry,
    ...rest,
  });
}

export function usePublicConfigValue(options = {}) {
  const { data } = usePublicConfig(options);
  return data || {};
}
